import React from 'react';
import Image from 'react-bootstrap/Image';
import { Col, Container, Row } from 'react-bootstrap';
import "../../assets/scss/project/show-case-desktop.scss"

import BrowserTop from './BrowserTop';
import IShowCaseTypes from '../../models/IShowCaseTypes';
import { IImage } from '../../models/IScreen';
import { IImage2 } from 'models/IScreen2';
import getExtension from 'service/script/getExtention';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

export interface IDesktopScreen extends IImage {
    type: IShowCaseTypes;
    fakeUrl: string;
}

export interface IDesktopScreen2 extends IImage2 {
    type: IShowCaseTypes;
    fakeUrl: string;
}

interface IProps {
    screen: IDesktopScreen;
}

function ProjectShowCaseDesktop(props: IProps) {


    const media = getExtension(props.screen.src) === "mp4" ?
        <video className="video" width="100%" loop autoPlay muted preload='auto'>
            <source src={props.screen.src} type="video/mp4" />
        </video> :
        <Image className="w-100" src={props.screen.src} alt={props.screen.alt} />;


    return (
        <Container >
            <Row>
                <Col>
                    <div className="show-case-desktop">
                        <div className="show-case-item rounded-corners">
                            <LazyLoadComponent threshold={500}>
                                <BrowserTop fakeUrl={props.screen.fakeUrl} />
                                {media}
                            </LazyLoadComponent>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ProjectShowCaseDesktop;